import { render } from "./HomeWhoWeAre.vue?vue&type=template&id=ce12da0e&scoped=true&ts=true"
import script from "./HomeWhoWeAre.vue?vue&type=script&lang=ts"
export * from "./HomeWhoWeAre.vue?vue&type=script&lang=ts"

import "./HomeWhoWeAre.vue?vue&type=style&index=0&id=ce12da0e&lang=stylus&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce12da0e"]])

export default __exports__